import { render, staticRenderFns } from "./TextEditorWithHeader.vue?vue&type=template&id=0c66bb7e&scoped=true"
import script from "./TextEditorWithHeader.vue?vue&type=script&lang=js"
export * from "./TextEditorWithHeader.vue?vue&type=script&lang=js"
import style0 from "./TextEditorWithHeader.vue?vue&type=style&index=0&id=0c66bb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66bb7e",
  null
  
)

export default component.exports